// extracted by mini-css-extract-plugin
export default {"admin_nav":"AdminNav_admin_nav__N-ddr","fix":"AdminNav_fix__cGMO5","fire":"AdminNav_fire__rvG5G","fix2":"AdminNav_fix2__09fZ5","subLink":"AdminNav_subLink__7TjNf"};